
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginSliceValue } from "../../redux/reducers/loginSlice";
  const useToggleStatus = () => {
    const { userDetails } = useSelector(loginSliceValue);
  const toggleClinicStatus = async ({
    clinicId,
    active,
  }: {
    clinicId: string;
    active: boolean;
  }) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/rtm/associated-clinic/${clinicId}`,
        { active}, 
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + userDetails.token,
              },
        }
      );


    if (response?.status === 201) {
      toast.success(response.data.msg);
      return response;
    }

   
    } catch (error) {
        toast.error('Something went wrong while updating status');
   
    }
  };

  return { toggleClinicStatus  };
};

export default useToggleStatus 
